import { Loader2, Facebook, Instagram, AlertTriangle, Heart, MessageCircle, Share2 } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleString("ro-RO", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Bucharest" });

const LinkBtn = ({ href, icon: Icon, label, testId }) => href
  ? <a href={href} target="_blank" rel="noreferrer" data-testid={testId} className="flex items-center gap-1.5 rounded-full bg-zinc-100 px-3 py-1 text-xs font-medium text-zinc-950 transition-colors hover:bg-amber-400"><Icon className="h-3.5 w-3.5" /> {label}</a>
  : <span className="flex items-center gap-1.5 rounded-full border border-zinc-800 px-3 py-1 text-xs text-zinc-600"><Icon className="h-3.5 w-3.5" /> fără link</span>;

const Stat = ({ icon: Icon, v, label }) => (
  <span className="flex items-center gap-1" title={label}><Icon className="h-3.5 w-3.5" />{v ?? "—"}</span>
);

const Stats = ({ st, pf, i }) => {
  if (!st) return null;
  if (st.error) return <span className="text-[11px] text-rose-300" data-testid={`history-stats-${pf}-${i}`}>statistici indisponibile</span>;
  return (
    <span className="flex items-center gap-2.5 text-xs text-zinc-300" data-testid={`history-stats-${pf}-${i}`}>
      <Stat icon={Heart} v={st.likes} label="Like-uri / reacții" />
      <Stat icon={MessageCircle} v={st.comments} label="Comentarii" />
      <Stat icon={Share2} v={st.shares} label="Distribuiri" />
    </span>
  );
};

export const HistoryList = ({ items }) => {
  if (items === null) return <Loader2 className="h-5 w-5 animate-spin text-zinc-500" />;
  if (!items.length) return <p className="text-sm text-zinc-500" data-testid="history-empty">Încă nu s-a publicat nicio postare.</p>;
  return (
    <div className="divide-y divide-zinc-800 overflow-hidden rounded-xl border border-zinc-800" data-testid="history-list">
      {items.map((p, i) => (
        <div key={i} data-testid={`history-item-${i}`} className="flex flex-wrap items-center gap-4 bg-zinc-900/40 p-4">
          {p.image_url ? <img src={p.image_url} alt="" className="h-16 w-16 shrink-0 rounded-lg bg-white object-contain" /> : <div className="h-16 w-16 rounded-lg bg-zinc-800" />}
          <div className="min-w-[200px] flex-1">
            <p className="text-sm font-medium text-zinc-100">{p.product_title || "—"}</p>
            <p className="text-xs text-zinc-500">{fmt(p.timestamp)} · {p.source === "cron" ? "automat" : p.source === "creative" ? "din Creative Ads" : "manual"}{p.video_url ? " · video" : ""}{p.stats?.updated_at ? ` · statistici ${fmt(p.stats.updated_at)}` : ""}</p>
            {p.caption_text && <p className="mt-1 line-clamp-2 whitespace-pre-line text-xs text-zinc-400">{p.caption_text}</p>}
            {!p.success && <p className="mt-1 flex items-center gap-1 text-xs text-rose-300"><AlertTriangle className="h-3.5 w-3.5" /> {p.error_message || "Eșuat"}</p>}
          </div>
          {p.story && !p.story.skipped && (
            <span className="flex items-center gap-1 text-[10px] text-zinc-400" data-testid={`history-story-${i}`}>
              Story: <span className={p.story.facebook?.posted ? "text-emerald-300" : "text-rose-300"}>FB {p.story.facebook?.posted ? "✓" : "✗"}</span>
              <span className={p.story.instagram?.posted ? "text-emerald-300" : "text-rose-300"}>IG {p.story.instagram?.posted ? "✓" : "✗"}</span>
            </span>
          )}
          {p.vs_avg_pct != null && (
            <span data-testid={`history-rank-${i}`} title={`Scor ${p.score} (like + 2×comentarii + 3×distribuiri), media lunii ${p.month_avg}`}
              className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${p.vs_avg_pct >= 0 ? "bg-emerald-500/15 text-emerald-300" : "bg-zinc-700 text-zinc-300"}`}>
              {p.vs_avg_pct >= 0 ? `+${p.vs_avg_pct}%` : `${p.vs_avg_pct}%`} față de media lunii
            </span>
          )}
          <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${p.success ? "bg-emerald-500/15 text-emerald-300" : "bg-rose-500/15 text-rose-300"}`}>{p.success ? "PUBLICAT" : "EȘUAT"}</span>
          {p.success && (
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-3">
                <LinkBtn href={p.fb_url} icon={Facebook} label="Facebook" testId={`history-fb-${i}`} />
                <Stats st={p.stats?.facebook} pf="fb" i={i} />
              </div>
              <div className="flex items-center gap-3">
                <LinkBtn href={p.ig_url} icon={Instagram} label="Instagram" testId={`history-ig-${i}`} />
                <Stats st={p.stats?.instagram} pf="ig" i={i} />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
